<template>
    <div :class="colGrid">
        <DataTable :value="dados ? dados : []" class="p-datatable-responsive table-seplag" dataKey="chave ? chave : ''" selectionMode="single"
                :paginator="paginacao ? paginacao : false" :rows="linhas ? linhas : 10" :filters="filtros" :resizableColumns="false" :scrollable="false" 
                @page="paginacaoEvent($event)"  :totalRecords.sync="totalRegistro" :lazy=true :loading="loading">
               
                 <template #header v-if="exibirCabecalho">
                    <div class="table-header p-grid p-fluid p-justify-between p-align-center">
                        <div class="p-col-12 p-md-8 ">
                            <div style="display:flex; flex-direction:row; justify-content: flex-start">
                                <div style="margin:5px">
                                    <Button label="Adicionar" icon="pi pi-plus" class="p-button-raised" @click="onAdicionarDado" v-if="onAdicionarDado" />
                                </div> 

                                <slot name="buttonsHeader"></slot>


                            </div>
                        </div>
                        <div class="p-col-12 p-md-4 table-search" v-if="onSearch">
                            <div class="p-grid p-fluid p-align-center">
                                <div class="p-col">
                                    <InputText 
                                        v-model="filtro" 
                                        :placeholder="placeholderSearch" 
                                        size="50" 
                                        @keyup.enter="onSearch(filtro)"
                                    />
                                </div>
                                <i class="pi pi-search " @click="onSearch(filtro)" style="cursor: pointer;"></i>
                            </div>    
                        </div>
                    </div>
                </template>
                <Column v-for="campo in camposTabela.filter(elemento => { return !elemento.ocultar })" :key="campo.nome" :headerStyle="larguraColuna(campo.tamanho)"
                    :field="campo.nome" :header="campo.titulo" :bodyStyle="alinhaColuna(campo.alinhamento)" >
                    <template #body="slotProps" >                
                        {{ colunaTabela(slotProps.data, campo) }}
                    </template>
                </Column>

                <slot></slot>

                <Column headerStyle="width: 8em" bodyStyle="text-align: center" 
                    header="Ação" v-if="hasEventoAcao">

                    <template #body="slotProps">                        
                        <Button type="button" icon="pi pi-pencil" @click="onEditarDado(slotProps.data)" v-if="onEditarDado"
                            class="p-button-success" :style="onExcluirDado ? 'margin-right: .5em' : ''"></Button>
                        <Button type="button" icon="pi pi-trash" @click="exibirTelaConfirmacao(slotProps.data)" v-if="onExcluirDado"
                            class="p-button-danger"></Button>
                    </template>
                </Column>
        </DataTable>

        <confirmacao tituloTela="Confirmação" v-model="exibirConfirmacao" 
                :onConfirmar="confirmarApagar" textoConfirmcao="Deseja realmente remover o regsitro selecionado?" />        
    </div>
</template>

<script>
import classeCss from '../common/grid'
import Confirmacao from './Confirmcao.vue'
import moment from 'moment'
import { baseApiUrl } from '@/config/global'

export default {
    name: 'TableSeplag',
    components: { Confirmacao },
    props: {
        tituloTabela: {
            // Especifica o titulo a ser exibido no cabeçalho da tabela
            type: String
        },
        
        cols: {
            // Numero de colunas do grid css
            type: String
        },
        paginacao: {
            // Informa se a grid trabalha com a paginação
            type: Boolean
        },
        exibirCabecalho: {
            // Informa se deve exibir o cabeçcalho
            type: Boolean,
            default: true
        },
        linhas: {
            // Número de linhas quando a grid é paginada
            type: Number
        },  
        urlPanagicao:{
            type: String
        },      
        queryPagina: {
          // Numero da pagina atual
          type: String,
          default : '?size=10&page=0'
        },
        totalRegistro: {
          // Total de registros do resultado
          type: Number,
          default: 0
        },
        dados: {
            // A coleção de dados que será renderizada na tabela
            type: Array
        },
        campos: {
            // Lista de campos que será utilizada para formatar a grid
            type: Array,
            required: true
        },
        chave: {
            // Nome do campo chave utilizado como chave dos dados
            type: String
        },
        onAdicionarDado: {
            // Evento disparado na adição do registro
            type: Function
        },
        onEditarDado: {
            // Evento disparado na edição do registro
            type: Function
        },
        onExcluirDado: {
            // Evento disparado na exclusão do registro
            type: Function
        },
        onCarregarDados: {
          // Evento disparado para carregar dados
          type: Function
        },
        placeholderSearch:{
            type:String,
            default:"Digite sua pesquisa"
        },
        onSearch:{
            type: Function
        },
        onSearchPaginacao:{
            type: Function,
            default: null
        },
    },
    computed: {
        colGrid() {
            return classeCss(this.cols ? this.cols : '12')
        },
        camposTabela() {
            return this.campos ? this.campos : []
        },
        hasEventoAcao(){
            return this.onEditarDado || this.onExcluirDado
        }
    },
    data() {
        return {
            filtro:'',
            filtros: {},
            exibirConfirmacao: false,
            registro: {},
            loading: false
        }
    },
    methods: {
        
        colunaTabela(objeto, campo) {            
            var dataColuna = ''
            if (campo.nome.indexOf('.') < 0) {                
                if(campo.displayFormat){
                    dataColuna = moment(objeto[campo.nome]).format(campo.displayFormat)
                    return dataColuna
                }           
                return  objeto[campo.nome]
            }            
            else {
                var arryCampos = campo.nome.split('.')
                let colunasArray = objeto
                for(let i=0;i<arryCampos.length;i++){
                    if(colunasArray[arryCampos[i]]){
                        colunasArray = colunasArray[arryCampos[i]]
                    }else{
                        break
                    }
                }         
                if(campo.displayFormat){
                    if(moment(colunasArray).isValid()){
                        dataColuna = moment(colunasArray).format(campo.displayFormat)
                        return dataColuna
                    }
                }                
                return colunasArray? typeof colunasArray != 'object'? colunasArray : 'Não Informado'  : ''
                // return objeto[arryCampos[0]][arryCampos[1]][arryCampos[2]] ? objeto[arryCampos[0]][arryCampos[1]][arryCampos[2]] : objeto[arryCampos[0]][arryCampos[1]]
            }
        },
        larguraColuna(tamanho) {
            // Retorna a columa da grid especificada dinamicamente
            if(tamanho && tamanho.indexOf('.')< 0){
                return tamanho ? `width: ${tamanho}px;` : ''                
            }else if (tamanho){
                let css = tamanho.split('.')
                return tamanho ? `width: ${css[0]}${css[1]};` : ''                
            }else{
                return ''
            }
        },
        alinhaColuna(alinhamento) {
            // Os tipos de valores para a propriedade alinhamento são: left, center, right
            if(alinhamento){
                return 'text-align: ' + alinhamento
            }
            else {
                return ''
            }
        },
        exibirTelaConfirmacao(dado){
            // Recebe o registro a ser removido
            this.registro = dado
            // Exibie a tela
            this.exibirConfirmacao = true
        },
        confirmarApagar(){
            // Dispara o evento
            this.onExcluirDado(this.registro)
        },
        async paginacaoEvent(event){
          
          if (this.onSearchPaginacao && this.filtro) {
                this.onSearchPaginacao(event.originalEvent.rows,event.originalEvent.page)
            }else{
                if(this.onSearchPaginacao){
                    this.onSearchPaginacao(event.originalEvent.rows,event.originalEvent.page)
                }else{
                    this.loading = true
                    let res = await this.$http.get(`${baseApiUrl}/${this.urlPanagicao}?size=${event.originalEvent.rows}&page=${event.originalEvent.page}`)
                    if(res.status == 200){
                        this.$emit('update:dados', res.data.content)
                        this.$emit('update:totalRegistro', res.data.totalElements)
                    }
                    this.loading = false
                }
            }
        },
    }
}
</script>

<style >
.p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
    display: none;
}

body .p-datatable.p-datatable-hoverable-rows 
    .p-datatable-tbody > tr:not(.p-highlight):not(.p-highlight-contextmenu):hover {
    background-color: #dbdbdb;
}

@media screen and (max-width: 40em) {
    .p-datatable-responsive .p-datatable-thead > tr > th,
    .p-datatable-responsive .p-datatable-tfoot > tr > td {
        display: none !important;
    }

    .p-datatable-responsive .p-datatable-tbody > tr > td {
        text-align: left !important;
        display: block;
        border: 0 none;
        width: 100% !important;
		float: left;
		clear: left;
    }

    .p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
        padding: .4em;
        min-width: 30%;
        display: inline-block;
        margin: -.4em 1em -.4em -.4em;
        font-weight: bold;
    }

    body .p-datatable .p-datatable-header {
        border-bottom: 1px solid #c8c8c8;
    }
}

.table-header.p-grid {
    margin-top: 0;
    padding: 0 10px 0 10px;
}

.table-search, .table-search .p-grid {
    padding: 0 5px 0 5px;
    margin-top: 0;
}

</style>